import { render, staticRenderFns } from "./ExtractionTemplateItemActions.vue?vue&type=template&id=4f8e440d&scoped=true&"
import script from "./ExtractionTemplateItemActions.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplateItemActions.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplateItemActions.vue?vue&type=style&index=0&id=4f8e440d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e440d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
